import * as React from 'react'

export const CommentIcon = ({
  size = 20,
  color = '#1B3029',
  ...props
}: { size?: number; color?: string } & React.SVGProps<SVGSVGElement>) => (
  <svg width={size} height={(size * 13) / 14} fill="none" viewBox="0 0 14 13" {...props}>
    <path
      fill={color}
      d="M9.424.197h-5.1A3.829 3.829 0 0 0 .5 4.022v2.974a3.83 3.83 0 0 0 3.612 3.82v1.772a.362.362 0 0 0 .616.255l.398-.399a5.506 5.506 0 0 1 3.92-1.623h.378a3.829 3.829 0 0 0 3.824-3.825V4.022A3.829 3.829 0 0 0 9.424.197ZM4.112 6.36a.85.85 0 1 1 .002-1.702.85.85 0 0 1-.002 1.702Zm2.762 0a.85.85 0 1 1 .002-1.702.85.85 0 0 1-.002 1.702Zm2.762 0a.85.85 0 1 1 .002-1.702.85.85 0 0 1-.002 1.702Z"
    />
  </svg>
)

export default CommentIcon
